export default __webpack_public_path__ + "static/media/arrow-down-black.136bdd40.svg";